// string foo, [production, staging, local]
export const config = (env) => {
    const production = {
        application: 'Chklsty',
        socket: {
            url: 'socket.chklsty.com'
        },
        jwt: {
            cookieName: 'chklsty_jwt'
        },
        stripe: {
            style: {
                base: {
                    color: '#32325d',
                        lineHeight: '18px',
                        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '16px',
                        '::placeholder': {
                        color:'#aab7c4'
                    }
                },
                invalid: {
                    color: '#fa755a',
                        iconColor: '#fa755a'
                }
            }
        }
    };
    const staging = {
        socket: {
            url: 'socket.chklsty.top'
        }
    };
    const local = {
        socket: {
            url: 'socket.chklsty.local:3001'
        }
    };
    switch (env) {
        case 'staging':
            return _.extend(production, staging);
        case 'local':
            return _.extend(production, local);
        default:
            return production;
    }
};
